export default {
    data(){
        return {
            globalServer: 'http://39.98.179.82:8081'
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js